<script lang="ts">
    import { Button, Col, Row, ButtonGroup } from "sveltestrap";
    import data from "../../../Data/ComponentData/Buttons/ButtonsGroup.json"
    import Card from "../../Core/Card.svelte";
    import { Left, Middle, OutlineCustombuttongroup, Right } from "../../../utils/Constant/Constant";
</script>

<Col xs='12'>
    <Card headerTitle={OutlineCustombuttongroup} cardBodyprops="btn-group-showcase">
        <div slot="contentbody">
            <Row>
                <Col xxl="4" md="6" sm="12">
                    <ButtonGroup class='btn-group-pill'>
                        <Button color="primary" >{Left}</Button>
                        <Button color="primary" outline>{Middle}</Button>
                        <Button color="primary" >{Right}</Button>
                    </ButtonGroup>
                </Col>
                {#each data.basicbuttondata as buttonData }
                    <Col xxl="4" md="6" sm="12" class={buttonData.class}>
                        <ButtonGroup class='btn-group-pill'>
                            {#each buttonData.buttongroup as buttonItem}
                                <Button outline={buttonItem.value} color={buttonItem.color} >{buttonItem.title}</Button>
                            {/each}
                        </ButtonGroup>
                    </Col>
                {/each}
            </Row>
        </div>
    </Card>
</Col>